import React, { Fragment, useState } from 'react';
import Modal from '../../common/Modal';
import Warning from './Warning';

const SubmitButton = ({ jobId, type="photography" }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [overridingAttributes, setOverridingAttributes] = useState([]);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const overwriteSubmit = (e, method) => {
    e.preventDefault();
    let formData = $($('.edit_djob')[0]).serialize();

    if (method === 'no_overwrite') {
      formData = formData + '&djob%5Bstrip_overridden_attributes%5D=true'
    }

    $.ajax({
      type: 'patch',
      url: `/djobs/${jobId}`,
      data: formData
    }).complete((data) => {
      if (data.status === 200) {
        if (typeof wasSubmitted === 'function') wasSubmitted();
        window.location.href = JSON.parse(data.responseText).link
      } else {
        alert("Something went wrong. Please reload and try again.");
      }
    });
  }

  const onClick = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = `${$($('.edit_djob')[0]).serialize()}&redirect=auto-submit`;

    $.ajax({
      type: 'get',
      url: `/djobs/${jobId}/check_for_overriding_attributes.json`,
      data: formData
    }).done((data) => {
      if (data.overriding_attributes.length === 0) {
        $.ajax({
          type: 'patch',
          url: `/djobs/${jobId}`,
          data: formData
        }).complete((data) => {
          if (typeof wasSubmitted === 'function') wasSubmitted();
          if (data.status === 200) {
            window.location.href = JSON.parse(data.responseText).link
          } else {
            window.location.href = `/djobs?type=${type}`
          }
        });
      } else {
        setOverridingAttributes(data.overriding_attributes);
        openModal();
      }
    });
  }

  return (
    <Fragment>
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Overriding Data Warning"
        headerText="You may be overwriting data"
        secondaryButton={<button className="btn btn-danger" onClick={(e) => overwriteSubmit(e, 'overwrite')}>Submit and overwrite values</button>}
        primaryButton={<button className="btn btn-primary" onClick={(e) => overwriteSubmit(e, 'no_overwrite')}>Submit without overwriting values</button>}
      >
        <Warning
          overridingAttributes={overridingAttributes}
          jobId={jobId}
        />
      </Modal>

      <button onClick={onClick} className="btn btn-primary">
        Update Job
      </button>
    </Fragment>
  )
}

export default SubmitButton;
